/* global Blob, FileReader, window */

import type { SharedStateKey } from "@/types";

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const setSharedState = (key: SharedStateKey, value: string) => {
  // @ts-ignore
  window.sharedState ||= {};
  // @ts-ignore
  window.sharedState[key] = value;
};
